const FILE_EXTENSION_PATTERN = /^\.[a-z0-9]+$/

export function normalizeFileExtension(raw: string): string {
  const trimmed = raw.trim()
  if (!trimmed) return ''

  const withoutDot = trimmed.startsWith('.') ? trimmed.slice(1) : trimmed
  const normalized = `.${withoutDot.toLowerCase()}`

  return FILE_EXTENSION_PATTERN.test(normalized) ? normalized : ''
}

export function parseFileTypes(value: string | undefined | null): string[] {
  if (!value?.trim()) return []

  const seen = new Set<string>()
  const result: string[] = []

  for (const part of value.split('/')) {
    const normalized = normalizeFileExtension(part)
    if (normalized && !seen.has(normalized)) {
      seen.add(normalized)
      result.push(normalized)
    }
  }

  return result
}

export function serializeFileTypes(extensions: string[]): string {
  const seen = new Set<string>()
  const result: string[] = []

  for (const ext of extensions) {
    const normalized = normalizeFileExtension(ext)
    if (normalized && !seen.has(normalized)) {
      seen.add(normalized)
      result.push(normalized)
    }
  }

  return result.join('/')
}
